import styled from 'styled-components'
import { AccommodationPackageTileGrid } from './AccommodationIndividualSelectRoomOptionTile'

export const AccommodationIndividualSelectRoomOptionTileSubgrid = styled.div`
  display: grid;

  @supports (grid-template-rows: subgrid) {
    grid-row: span 2;
    grid-template-rows: subgrid;

    & > ${AccommodationPackageTileGrid} {
      grid-row: 2;
    }
  }
`
